// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"a01cf01e","868":"a01cf01e","996":"a01cf01e"}[chunkId] + ".chunk.css";
};